import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import MemberProfile from "../../../member/profile/components/MemberProfile";
import References from "../components/references/References";

import * as commonActions from "../../../../../actions/common.actions";
import * as adminActions from "../../../../../actions/admin.actions";
import * as userActions from "../../../../../actions/user.actions";
import * as dropdownsActions from "../../../../../actions/dropdowns.actions";

import styles from "./AdminMemberProfileContainer.scss";

const subHeader = memberId => ({
  items: [
    {
      caption: "Profile",
      url: `/admin/member/approved/${memberId}/profile`
    },
    {
      caption: "Matches",
      url: `/admin/member/approved/${memberId}/matches`
    },
    {
      caption: "Pitches",
      url: `/admin/member/approved/${memberId}/pitches`
    },
    {
      caption: "SOWs",
      url: `/admin/member/approved/${memberId}/sows`
    }
  ],

  activeItem: 0
});

class AdminMemberProfileContainer extends Component {
  constructor(props) {
    super(props);

    this.props.adminActions.getUser(this.props.match.params.memberId);
    this.props.userActions.getUserStatusList();
    this.props.dropdownsActions.fetchWorkRelationships();

    this.downloadResume = this.downloadResume.bind(this);

    //this.contactApplicant = this.contactApplicant.bind(this);

    this.sendReminderReference = this.sendReminderReference.bind(this);
    this.approveReference = this.approveReference.bind(this);
    this.rejectReference = this.rejectReference.bind(this);
    this.addReference = this.addReference.bind(this);
  }

  componentDidMount() {
    this.props.commonActions.setSubHeader(
      subHeader(this.props.match.params.memberId)
    );
  }

  componentWillUnmount() {
    this.props.commonActions.setSubHeader({});
    this.props.commonActions.setHeaderBar({});
  }

  downloadResume(e) {
    e.preventDefault();

    // Flag to know if we need to download the resume or just view (open) it
    const download = e.target.dataset.download === "true";

    if (this.props.match.params.memberId) {
      this.props.userActions.downloadResume(
        this.props.match.params.memberId,
        download
      );
    }
  }

  /* update reference status functions */

  sendReminderReference(reference_id) {
    this.props.adminActions.sendReminderReference({
      reference_id
    });
  }

  approveReference(reference_id) {
    const userId = this.props.match.params.memberId;

    this.props.adminActions.approveReference(
      {
        reference_id,
        approved: true
      },
      userId
    );
  }

  rejectReference(reference_id) {
    const userId = this.props.match.params.memberId;

    this.props.adminActions.approveReference(
      {
        reference_id,
        approved: false
      },
      userId
    );
  }

  addReference(data) {
    data.user_id = this.props.match.params.memberId;

    this.props.adminActions.adminAddReference(data);
  }

  filterNoRejectedReferences() {
    const references = _.get(this.props.admin, "user.work_references") || [];

    //return the no rejected references
    return references.filter(reference => {
      const approved = _.get(reference, "approval.approved");
      const declined = _.get(reference, "declined");

      return approved !== false && !declined;
    });
  }

  render() {
    const member = this.props.admin.user;

    const references = this.filterNoRejectedReferences();
    const referencesProps = {
      references,
      memberName: member.first_name + " " + member.last_name,
      memberEmail: this.props.admin.user.email,
      approveReference: this.approveReference,
      rejectReference: this.rejectReference,
      sendReminderReference: this.sendReminderReference,
      addReference: this.addReference,
      workRelations: this.props.workRelations
    };

    return (
      <div>
        <MemberProfile
          memberData={member}
          downloadResume={this.downloadResume}
        />
        <div className={styles.doubleBorder} />
        <References {...referencesProps} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    admin: state.admin,
    user: state.user,
    workRelations: state.dropdowns.workRelationship.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    dropdownsActions: bindActionCreators(dropdownsActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminMemberProfileContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/memberApprovedProfile/profile/containers/AdminMemberProfileContainer.js